
import React, { Component } from 'react';
import './add-new-contact.scss'
import ReactTooltip from 'react-tooltip';

import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown';
import DropdownV3 from '../../common/dropdown-v3/dropdown';
import CommonApi from '../../../apis/common'
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CommonUtils from '../../../utility/common-utilities';

class AddContactComponent extends Component {

    state = {
        isAddNew: false,
        types: [{ type: "MATH_TEACHER" }],
        selectedCountryCode: '+91',
        gender: 'Mr.',
        countryCodeDropdown: [],
        staffTypesDropdown: [],
        mathSelected: true,
        isAddNew: true,
        sections: [],
        classes: [],
        selectedClasses: [{ class: "", sections: [] }],
        board: "",
        boards: [],
        selectedClass: ""
    }

    dropdown = []
    countryCodeHash = {}

    constructor(props) {
        super(props)
        this.state.classes = this.props.classes
        this.state.boards = this.props.boards
        this.state.board = this.state.boards?.length ? this.state.boards[0].value : ""
        if (this.props.mode === 'EDIT') {
            this.state.isAddNew = true
            this.state.validation = true
            this.state.selectedUser = this.props.selectedUser;
            this.state.firstName = this.props.selectedUser.firstName;
            this.state.lastName = this.props.selectedUser.lastName;
            this.state.email = this.props.selectedUser.email;
            this.state.selectedCountryCode = this.props.selectedUser.countryCode;
            this.state.mobileNumber = this.props.selectedUser.mobileNumber;
            this.state.landline = this.props.selectedUser.landline;
            this.state.gender = this.props.selectedUser.gender
            this.state.board = this.props.selectedUser.board
            let classSelected = this.props.selectedUser.types.filter(type => type.type == "MATH_HOD")
            let mathSelected = this.props.selectedUser.types.filter(type => type.type == "MATH_TEACHER")
            this.state.selectedTypes = this.props.selectedUser?.types?.map(type => type?.type) || []
            this.state.types = this.props.selectedUser?.types
            if (mathSelected.length) {
                this.state.mathSelected = true
            }
            if (classSelected.length) {
                this.state.classSelected = true
            }
            if (this.props.from === "teacher-list") {
                this.udpateClassesAndSections(this.props.selectedUser.classes)
            }
        }

    }

    udpateClassesAndSections = classes => {
        const selectedClasses = []
        const selectedSections = []
        let board = ""
        if (classes && classes.length > 0) {
            classes.map(c => {
                const idx = selectedClasses.findIndex(sc => sc.class == c.class && sc.board == c.board)
                if (idx > -1) {
                    selectedClasses[idx].class = c.class
                    selectedClasses[idx].board = c.board
                    if (!selectedClasses[idx].sections) selectedClasses[idx].sections = []
                    selectedClasses[idx].sections.push(c.sectionId)
                    selectedSections[idx].push({ title: c.section, value: c.sectionId })
                } else {
                    selectedClasses.push({ board: c.board, class: c.class, sections: [c.sectionId] })
                    let length = selectedClasses.length - 1
                    selectedSections[length] = []
                    selectedSections[length].push({ title: c.section, value: c.sectionId })
                }
                board = c.board
            })
            this.state.selectedClasses = selectedClasses
            selectedSections.map((ss, index) => {
                this.getSections({ board: selectedClasses[index].board, class: selectedClasses[index].class }, index, true)
            })
        }
        this.state.board = board
    }

    genderDropdown = Constants.SCHOOL_ONBOARD.GENDER_LIST
    userHash = {}

    componentDidMount() {
        this.getStaffTypesDetails()
        this.getCountryCodes();
        if (!this.state.isAddNew) {
            this.getStaffs()
        }
    }

    getSections(payload = {}, index = 0, isEdit) {
        const { boards } = this.props
        const { selectedClasses } = this.state
        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = boards[0].title
        SchoolApi.getSections(payload)
            .then(response => {
                const { sections } = this.state
                sections[index] = []
                for (let i = 0; i < response.response.length; i++) {
                    sections[index].push({
                        title: response.response[i].section,
                        value: response.response[i]._id,
                    })
                }

                this.setState({ sections }, _ => {
                    if (this.dropdown[index]) {
                        if (isEdit && payload.board && payload.class) {
                            const filteredClass = selectedClasses.filter(sc => sc.class === payload.class && sc.board === payload.board)
                            console.log(filteredClass)
                            if (filteredClass.length > 0 && filteredClass[0].sections?.length > 0) {
                                filteredClass[0].sections.map(fc => {
                                    const idx = sections[index].findIndex(s => s.value === fc)
                                    console.log(idx)
                                    if (idx > -1) {
                                        this.dropdown[index].onClickOption(sections[index][idx])
                                    }
                                })
                            }
                        }
                        this.dropdown[index].resetMulitSelectDropdown()
                    }
                })
            }).catch(err => {
            })
    }

    getStaffs(payload = {}) {
        SchoolApi.getStaffs(payload)
            .then(response => {
                let items = [];
                this.userHash = {}
                for (let i = 0; i < response?.response?.length; i++) {
                    items.push({
                        title: `${response?.response[i].firstName} ${response?.response[i].lastName || ""}`,
                        value: response?.response[i]._id,
                    })
                    this.userHash[response?.response[i]?._id] = response?.response[i]
                }

                this.setState({ existingUsersDropdown: items, showDropdown: true })
            }).catch(err => {
            })

    }

    onAddAsTeacher() {
        if (this.state.isSubmit) {
            return

        }

        let types = this.captureTypes()
        if (!types?.length) {
            this.setState({ errorMessage: "Please Select types" })
            return
        }

        if (!this.state.selectedUser) {
            this.setState({ errorMessage: "Please Select user" })
            return
        }

        let user = this.userHash[this.state.selectedUser]
        if (!user?.types || !user.types.length) user.types = []

        types = [...user.types, ...types]
        let typeHash = {}, newTypes = []

        for (let i = 0; i < types.length; i++) {

            let type = types[i]

            if (!typeHash[type?.type]) {
                typeHash[type?.type] = true
                newTypes.push(type)
            }

        }

        let payload = {
            _id: user?._id,
            types: newTypes,
        }

        this.setState({ isSubmit: true })

        SchoolApi.updateStaff(payload).then(response => {
            this.props.onClose()
            this.setState({ isSubmit: false })
        }).catch(err => {
            this.setState({ isSubmit: false })
        })
    }

    getStaffTypesDetails(payload = {}) {
        payload.types = "nin/SUPER_ADMIN"
        SchoolApi.getStaffTypes({ ...payload, schoolCode: this.props.schoolCode })
            .then(staffTypes => {
                const types = this.state.types
                let items = [];
                for (let i = 0; i < staffTypes.response.length; i++) {
                    items.push({
                        title: staffTypes.response[i].displayType,
                        value: staffTypes.response[i].type,
                    })
                }

                this.setState({ staffTypesDropdown: items, types })
            }).catch(err => {
            })
    }
    getCountryCodes(payload) {

        CommonApi.getCountryCodeList(payload).then(response => {
            let data = response.response
            if (data.length) {
                this.setState({ countryList: data })
                let countryCodeDropdown = this.buildCountryCodeDropdown(data)
                this.setState({ countryCodeDropdown: countryCodeDropdown })

            }
        }).catch(err => {
        })

    }

    onCountryCodeSearch(value, index) {
        if (value.length > 2 || !value) {
            this.countryCodeIndex = index
            this.getCountryCodes({ name: `/${value}`, })
        }
    }

    onSelectCountryCode(option) {
        this.setState({ selectedCountryCode: option?.value }, _ => {
            this.localValidation()
        })
    }

    buildCountryCodeDropdown(list = []) {
        let countryCodeDropdown = [];
        
        for (let i = 0; i < list.length; i++) {
            let item = list[i]

            if (!this.countryCodeHash[item.dialCode]) {
                this.countryCodeHash[item.dialCode] = item
                countryCodeDropdown.push({ title: `${item.name} ${item.dialCode}`, value: item.dialCode })
            }
        }

        console.log(this.countryCodeHash)

        return countryCodeDropdown
    }

    onSelectType = (option) => {
        console.log(option)
        let types = option.map(item => ({ type: item?.value }))
        console.log(types)
        this.setState({ types }, _ => {
            this.localValidation()
        })
    }

    captureTypes = () => {
        let types = []
        if (this.state.classSelected) {
            types.push({ type: "MATH_HOD" })
        }
        if (this.state.mathSelected) {
            types.push({ type: "MATH_TEACHER" })
        }

        return types

    }

    onSelectGender = (option) => {
        this.setState({ gender: option?.value }, _ => {
            this.localValidation()
        })
    }

    onSelectClass = (option, index) => {
        const { selectedClasses } = this.state
        selectedClasses[index].class = option?.value
        this.setState({ selectedClasses }, _ => {
            this.getSections({ board: selectedClasses[index].board, class: option?.value }, index)
            this.localValidation()
        })
    }

    onSelectBoard = (option, index) => {
        const { selectedClasses } = this.state
        selectedClasses[index].board = option?.value
        this.setState({ selectedClasses }, _ => {
            if (selectedClasses[index].class) this.getSections({ board: option?.value, class: selectedClasses[index].class }, index)
            this.localValidation()
        })
    }

    onSelectSection = (options, index) => {
        const { selectedClasses } = this.state
        selectedClasses[index].sections = options.map(opt => opt.value)
        this.setState({ selectedClasses }, _ => {
            if (this.dropdown[index]) this.dropdown[index].toggleExpandView()
            this.localValidation()
        })
    }

    onChangeHandler = (event, key) => {
        if (key == "mobileNumber" && !this.state.mobileNumber) {
            if (!CommonUtils.isAllowMobileNumber(event.target.value)) {
                let stateValue = this.state.mobileNumber
                this.setState({ mobileNumber: "" }, () => {
                    this.setState({ mobileNumber: stateValue }, () => {
                        this.localValidation()
                    })
                })
                return
            }
        }
        this.setState({ [key]: event.target.value }, () => {
            this.localValidation()
        })
    }

    onSave() {

        if (!this.state.isAddNew) {
            this.onAddAsTeacher()
            return
        }

        this.setState({ isSubmit: true })

        let payload = this.preparePayload()

        if (!this.validatePayload(payload)) return

        this.setState({ isSaving: true })

        if (this.props.mode === 'EDIT') {

            payload['_id'] = this.props.selectedUser._id

            SchoolApi.updateStaff(payload).then(response => {
                if (this.props.onClose) {
                    this.props.onClose()
                }
            }).catch(err => {
                this.setState({ isSaving: false })
                if (err.response && err.response.data && err.response.data.code == 11000) {
                    this.setState({ errorMessage: 'EmailId already exists' })
                }
            })
        } else {
            SchoolApi.createStaff(payload).then(response => {
                if (this.props.onClose) {
                    this.props.onClose(response?.data?.id)
                }
            }).catch(err => {
                this.setState({ isSaving: false })
                if (err.response && err.response.data && err.response.data.code == 11000) {
                    this.setState({ errorMessage: 'EmailId already exists' })
                }
            })
        }
    }

    preparePayload() {
        return {
            types: this.state.types,
            gender: this.state.gender,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email ? this.state.email.trim() : "",
            countryCode: this.state.selectedCountryCode,
            mobileNumber: this.state.mobileNumber,
            landline: this.state.landline,
            sections: this.prepareSections()
        }
    }

    prepareSections = _ => {
        const { selectedClasses } = this.state
        const sections = []
        selectedClasses.map(sc => {
            sc.sections.map(s => sections.push(s))
        })
        return sections
    }

    validatePayload(payload = {}, dontShowErrorMessage) {

        if (!payload.types || !payload.types?.length) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please select type" })
            return false
        }

        if (!payload.gender) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please select gender" })
            return false
        }

        if (!payload.firstName) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please enter first name" })
            return false
        }
        if (!payload.lastName) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please enter last name" })
            return false
        }
        if (!this.validateEmail(payload.email) || !payload.email) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Invalid email" })
            return false
        }

        if (!payload.countryCode) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please select country code" })
            return false
        }


        let countryCodeDetail = this.countryCodeHash[payload.countryCode]
        let validateCountryCode = CommonUtils.validateMobileNumber(payload.mobileNumber, countryCodeDetail)

        console.log(validateCountryCode, countryCodeDetail)

        if (!validateCountryCode) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please enter valid mobile number" })
            return false
        }

        if (this.props.from === "teacher-list" && (!payload.sections || !payload.sections.length)) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please select class & section" })
            return false
        }

        return true
    }

    validateEmail(value) {
        if (value) {
            let isValid = CommonUtils.validateEmail(value);
            if (!isValid) {
                this.setState({ isInvalidEmail: true });
                return false
            }
            else {
                this.setState({ isInvalidEmail: false })
                return true
            }
        } else {
            this.setState({ isInvalidEmail: true });
            return false
        }
    }

    onCheckType = (type) => {

        if (type == 'MATH') {
            this.setState({ mathSelected: !this.state.mathSelected }, () => {
                this.localValidation()
            })
        }

        if (type == 'HOD') {
            this.setState({ classSelected: !this.state.classSelected }, () => {
                this.localValidation()
            })
        }
    }

    addNewContact = () => {
        this.setState({ isAddNew: true })
    }

    onSelectUser = (option) => {
        this.setState({ selectedUser: option?.value })
    }

    localValidation() {
        let payload = this.preparePayload()
        let validate = this.validatePayload(payload, true)
        console.log(validate)
        this.setState({ validation: validate, errorMessage: "" })
    }

    addNewClass = _ => {
        const { selectedClasses } = this.state
        selectedClasses.push({ class: "", sections: [] })
        this.setState({ selectedClasses })
    }

    removeClass = index => {
        const { selectedClasses } = this.state
        selectedClasses.splice(index, 1)
        this.setState({ selectedClasses })
    }

    showAddSection = (selectedClass, selectedRow) => {
        this.props.showSetupSectionModal(selectedClass, selectedRow)
    }

    render() {
        const { selectedClasses, classes, sections, boards, board } = this.state
        return (

            <div className="add-teacher-new-contact">

                {
                    !this.state.isAddNew ?
                        <div>
                            <div className='text-center py-3'>
                                <label className='pr-3' onClick={() => this.onCheckType('MATH')}>
                                    {/* <input type='checkbox' checked={this.state.mathSelected} /> */}
                                    {this.state.mathSelected ?
                                        <div className='active-checkbox d-inline-block '>
                                            <img className="img" src={getImageSource(ImageConstants.ACTIVE_TICK)} />
                                        </div>
                                        :
                                        <div className='inactive-checkbox d-inline-block '>
                                            <img className="d-inline-block img" src={getImageSource(ImageConstants.INACTIVE_TICK)} />
                                        </div>

                                    }
                                    <span className=''><small className='teacher-type'>TYPE : MATH TEACHER</small></span>
                                </label>

                                <label onClick={() => this.onCheckType('HOD')}>
                                    {this.state.classSelected ?
                                        <div className='active-checkbox d-inline-block'>
                                            <img className="d-inline-block img" src={getImageSource(ImageConstants.ACTIVE_TICK)} />
                                        </div>
                                        :
                                        <div className='inactive-checkbox d-inline-block'>
                                            <img className="d-inline-block img" src={getImageSource(ImageConstants.INACTIVE_TICK)} />
                                        </div>

                                    }
                                    <span><small className='teacher-type'>TYPE : MATH HOD</small></span>
                                </label>
                            </div>
                            <div className='row pt-5'>
                                <div className='col-2'></div>
                                <div className='col-8'>
                                    <div className='cw-input-label'>SELECT FROM EXISTING CONTACTS</div>
                                    {

                                        this.state.showDropdown ?
                                            <Dropdown
                                                key="users"
                                                placeholder='Select from the list'
                                                options={this.state.existingUsersDropdown}
                                                onSelect={(option) => this.onSelectUser(option)}
                                                text="title"
                                                style={{ background: "#F6F7F5" }}
                                                invalid={this.state.isSubmit && !this.state.selectedUser}
                                            /> : ""}
                                </div>
                                <div className='col-2 add-icon-wrapper'>
                                    <img className="custom-add-icon cursor-pointer" onClick={this.addNewContact} src={getImageSource(ImageConstants.ADD)} />
                                </div>

                            </div>
                        </div>
                        :
                        <div>
                            {
                                !this.props.hideDefaultType ?
                                    <div className='bw-spaces-input'>
                                        <label className='pr-3'>
                                            <span className=''>TYPE : <small className='teacher-type'>MATHS TEACHER</small></span>
                                        </label>
                                    </div> : ""
                            }
                            {this.props.mode === "EDIT" &&
                                <div className='row bw-spaces-input'>
                                    <div className='col'>
                                        <label className='cw-input-label'>TYPE <span className='star'>*</span></label>
                                        {
                                            this.state.staffTypesDropdown?.length ?
                                                <Dropdown
                                                    multiSelect
                                                    placeholder='Select Type'
                                                    options={this.state.staffTypesDropdown}
                                                    onSelect={(option) => this.onSelectType(option)}
                                                    text={"title"}
                                                    style={{ background: "#F6F7F5" }}
                                                    value={this.state.selectedTypes || []}
                                                    invalid={this.state.isSubmit && !this.state?.selectedTypes?.length}
                                                /> : ""}
                                    </div>
                                </div>
                            }
                            <div className='bw-spaces-input'>
                                <div className='cw-input-label'>NAME <span className='star'>*</span></div>
                                <div className='row '>
                                    <div className='col-2'>
                                        <Dropdown
                                            key="gender"
                                            placeholder='Mr.'
                                            options={this.genderDropdown}
                                            onSelect={(option) => this.onSelectGender(option)}
                                            text="title"
                                            style={{ background: "#F6F7F5" }}
                                            value={this.state.gender}
                                            invalid={this.state.isSubmit && !this.state.gender}
                                        />
                                    </div>
                                    <div className='col'>
                                        <input className={`cw-input ${this.state.isSubmit && !this.state.firstName ? "invalid" : ""}`} placeholder='Enter First Name'
                                            value={this.state.firstName}
                                            onChange={(e) => this.onChangeHandler(e, 'firstName')} />
                                    </div>
                                    <div className='col'>
                                        <input className={`cw-input ${this.state.isSubmit && !this.state.lastName ? "invalid" : ""}`} placeholder='Enter Last Name'
                                            value={this.state.lastName || ""}
                                            onChange={(e) => this.onChangeHandler(e, 'lastName')} />
                                    </div>
                                </div>
                            </div>


                            <div className='row bw-spaces-input'>
                                <div className='col'>
                                    <label className='cw-input-label'>EMAIL ID <span className='star'>*</span></label>
                                    <input className={`cw-input ${(this.state.isSubmit && !this.state.email) || this.state.isInvalidEmail ? "invalid" : ""}`} placeholder='Enter Email Id'
                                        value={this.state.email}
                                        onChange={(e) => this.onChangeHandler(e, 'email')} />
                                </div>
                            </div>

                            <div className='row bw-spaces-input '>
                                <div className='col-8'>
                                    <div>
                                        <label className='cw-input-label no-padding'>MOBILE NUMBER</label>
                                    </div>
                                    {
                                        this.state.countryCodeDropdown?.length ?
                                            <div className="col-4 pl-0 d-inline-block">
                                                <Dropdown
                                                    key="countryCode"
                                                    placeholder='Search country code'
                                                    options={this.state.countryCodeDropdown}
                                                    onSelect={(option) => this.onSelectCountryCode(option)}
                                                    text="title"
                                                    onSearch={(value) => this.onCountryCodeSearch(value)}
                                                    style={{ background: "#F6F7F5" }}
                                                    value={this.state.selectedCountryCode}
                                                />
                                            </div> : ""
                                    }
                                    <div className="col-8 d-inline-block">
                                        <div className="text-right optional-text"></div>
                                        <input className={`cw-input ${this.state.isSubmit && (!this.state.mobileNumber || this.state.mobileNumber.length < 10) ? "invalid" : ""}`} placeholder='Enter Mobile Number'
                                            value={this.state.mobileNumber}
                                            onChange={(e) => this.onChangeHandler(e, 'mobileNumber')} />
                                    </div>
                                </div>
                                <div className='col-4'>
                                    <label className='cw-input-label no-padding'>LANDLINE</label>
                                    <div className="text-right "><span className='optional-text'>OPTIONAL</span></div>
                                    <input className={`cw-input`} placeholder='Enter Landline'
                                        value={this.state.landline}
                                        onChange={(e) => this.onChangeHandler(e, 'landline')} />
                                </div>
                            </div>


                            {/* <div className='row bw-spaces-input '>
                                <div className="col">
                                    <label onClick={() => this.onCheckType('HOD')}>
                                        {this.state.classSelected ?
                                            <img className="d-inline-block img cursor-pointer" src={getImageSource(ImageConstants.ACTIVE_TICK)} />
                                            :
                                            <img className="d-inline-block img cursor-pointer" src={getImageSource(ImageConstants.INACTIVE_TICK)} />

                                        }
                                        <span className="pl-2"><small className='teacher-type'>TYPE : MATH HOD</small></span>
                                    </label>
                                </div>
                            </div> */}
                            {this.props.from === "teacher-list" &&
                                <>
                                    <div className='row bw-spaces-input'>
                                        <div className='col-12 cw-label-container'>
                                            <label className='cw-input-label no-padding'>
                                                CLASS/SECTION
                                            </label>
                                        </div>
                                    </div>
                                    {selectedClasses.map((c, index) =>
                                        <>
                                            <div className='row mt-1 grouped-dropdown-container' key={index} onMouseEnter={ReactTooltip.rebuild}>
                                                {boards?.length > 1 && (
                                                    <div className='col-3 pr-0 grouped-dropdown first'>
                                                        <Dropdown
                                                            placeholder='Board'
                                                            options={boards}
                                                            onSelect={option => this.onSelectBoard(option, index)}
                                                            text='title'
                                                            style={{ background: '#F6F7F5' }}
                                                            value={c.board}
                                                        />
                                                        <div className='divider'></div>
                                                    </div>
                                                )}
                                                <div className={`${boards?.length > 1 ? 'col-3' : 'col-4'} pl-0 pr-0 grouped-dropdown`}>
                                                    {this.state.classes?.length && (
                                                        <Dropdown
                                                            placeholder='Class'
                                                            options={classes}
                                                            onSelect={option => this.onSelectClass(option, index)}
                                                            text='title'
                                                            style={{ background: '#F6F7F5' }}
                                                            value={c.class}
                                                        />
                                                    )}
                                                    <div className='divider'></div>
                                                </div>
                                                <div className={`${boards?.length > 1 ? 'col-6' : 'col-8'} pl-0 pr-0 grouped-dropdown last`}>
                                                    <Dropdown
                                                        ref={el => this.dropdown[index] = el}
                                                        placeholder='Sections'
                                                        options={this.state.sections[index]}
                                                        onSelect={options => this.onSelectSection(options, index)}
                                                        text='title'
                                                        style={{ background: '#F6F7F5' }}
                                                        value={c.sections}
                                                        multiSelect={true}
                                                        hideAllDelete={true}
                                                    />
                                                </div>
                                                <div className='remove-class'>
                                                    {((c.class && c.board) || (c.class && boards.length === 1)) &&
                                                        <div className='cursor-pointer mr-1' data-tip={"Add New Section"} onClick={_ => this.showAddSection(c.class, index)}>
                                                            <img
                                                                src={getImageSource(ImageConstants.ADD)}
                                                                className='add-remove-icon'
                                                            ></img>
                                                        </div>
                                                    }
                                                    {index > 0 &&
                                                        <div className='remove-class cursor-pointer' onClick={_ => this.removeClass(index)}>
                                                            <img
                                                                src={getImageSource(ImageConstants.DELETE_RED)}
                                                                className='close-icon'
                                                            ></img>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className='text-right'>
                                        <span className='add-new-class' onClick={this.addNewClass}>+ Add Class</span>
                                    </div>
                                </>
                            }
                        </div>
                }
                <div className="text-center pt-4">
                    {this.state.errorMessage ? <div className="text-danger pb-4"><strong>{this.state.errorMessage} </strong></div> : ""}

                    <button className={`cw-button-primary ${!this.state.validation ? "disable-button" : ""}`} onClick={() => this.onSave()}>
                        Save
                    </button>
                </div>
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>
        );
    }
}

export default AddContactComponent;